export default "__VITE_ASSET__47c62b51__"